import { render, staticRenderFns } from "./UcAccountMiniCard.yaml?vue&type=template&id=389ef9ef&component"
import script from "./UcAccountMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcAccountMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports